import Swiper from 'swiper/bundle';

export default function initializeIconBoxesAnimation() {
    document.querySelectorAll('.block-icon-boxes-animation').forEach(function(block) {
        new IconBoxesAnimation(block);
    });
}

class IconBoxesAnimation {
    constructor(block) {
        this.block = block;
        this.init();
    }

    init() {
        const slider = this.block.querySelector('.block-icon-boxes-animation__slider:not(.block-icon-boxes-animation__slider--disabled)');
        const swiper = new Swiper(slider, {
            slidesPerView: "auto",
            grabCursor: true,
            speed: 1000,
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
        });
    }
}
